<template>
  <div class="welcome-page">
    <div class="sidebar-wrapper">
      <button class="hamburger" @click="sidebarOpen = !sidebarOpen">☰</button>
      <div class="sidebar" :class="{ open: sidebarOpen }">
        <div class="sidebar-header">
          <button class="close-btn" @click="sidebarOpen = false">✖</button>
          <p>{{ user.fullname }}</p>
          <p>{{ user.phone_number }}</p>
        </div>
        <ul class="sidebar-menu">
          <li @click="goToPage('SignupPage')">Sign Up</li>
          <li @click="goToPage('WelcomePage')">Welcome</li>
        </ul>
      </div>
    </div>

    <div class="card">
      <div class="icon-circle">
        <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#ba71ff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
        </svg>
      </div>
      <h1 class="welcome-title">Welcome to PetMyPet!</h1>
      <p class="welcome-sub">You're all set. Start exploring pets near you and make a new furry friend today.</p>
      <button class="cta-btn" @click="goToPage('DashboardPage')">Go to Dashboard</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WelcomePage',
  props: {
    user: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return { 
      sidebarOpen: false
    };
  },
  methods: {
    goToPage(pageName) {
      this.sidebarOpen = false;
      this.$emit('change-page', pageName);
    }
  }
}
</script>
<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.welcome-page {
  min-height: 100vh;
  background: #fffbe8;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

/* ── Card ── */
.card {
  width: 100%;
  max-width: 420px;
  background: #ffffff;
  border-radius: 28px;
  border: 1px solid #f0e0ff;
  padding: 44px 32px 40px;
  box-shadow: 0 8px 32px rgba(186, 113, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.icon-circle {
  width: 76px;
  height: 76px;
  background: #f3eeff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.welcome-title {
  font-size: 24px;
  font-weight: 800;
  color: #1a1a1a;
  letter-spacing: -0.3px;
  margin: 0;
}

.welcome-sub {
  font-size: 14px;
  color: #aaa;
  font-weight: 500;
  line-height: 1.6;
  margin: 0;
}

.cta-btn {
  width: 100%;
  padding: 14px;
  background: #eac7ff;
  color: #4a1070;
  border: none;
  border-radius: 14px;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
  transition: background 0.18s, transform 0.1s;
  font-family: inherit;
  margin-top: 8px;
}

.cta-btn:hover  { background: #ba71ff; color: #fff; }
.cta-btn:active { transform: scale(0.98); }

/* ── Hamburger ── */
.hamburger {
  position: fixed;
  top: 20px;
  left: 20px;
  font-size: 28px;
  background: none;
  border: none;
  cursor: pointer;
  z-index: 1000;
  color: #4a1070;
}

/* ── Sidebar ── */
.sidebar {
  width: 240px;
  background-color: white;
  box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 0;
  position: fixed;
  top: 0;
  left: -240px;
  height: 100%;
  transition: left 0.3s ease;
  z-index: 1000;
}

.sidebar.open { left: 0; }

.sidebar-header {
  background: linear-gradient(135deg, #eac7ff 0%, #dda6fd 100%);
  padding: 20px;
  color: #4a1070;
  position: relative;
  overflow: hidden;
}

.sidebar-header::before,
.sidebar-header::after {
  content: '';
  position: absolute;
  width: 30px;
  height: 30px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 50% 50% 50% 50% / 60% 60% 40% 40%;
}

.sidebar-header::before {
  top: 10px;
  left: 10px;
  transform: rotate(45deg);
}

.sidebar-header::after {
  top: 40px;
  right: 20px;
  transform: rotate(-15deg);
}

.sidebar-header p {
  position: relative;
  z-index: 1;
  margin: 4px 0;
  font-weight: 600;
  color: #4a1070;
}

.close-btn {
  background: none;
  border: none;
  font-size: 22px;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
  color: #4a1070;
  z-index: 2;
}

.sidebar-menu {
  list-style: none;
  padding: 16px 20px 20px;
}

.sidebar-menu li {
  padding: 20px 0;
  cursor: pointer;
  font-size: 15px;
  color: #333;
  border-bottom: 1px solid #fdf5ff;
  transition: all 0.2s ease;
}

.sidebar-menu li:last-child { border-bottom: none; }

.sidebar-menu li:hover {
  color: #ba71ff;
  transform: translateX(4px);
}
</style>